export default "__VITE_ASSET__BWKoQ8JJ__"